import { Button, Typography, useMobile } from '@sonnen/web-ui';
import clsx from 'clsx';
import { REFRESH_OFFER_EVENT } from '../../constants';
import { useTranslation } from '../../i18n/i18n';
import { useOfferContext } from '../../OfferContext/OfferContext';
import { OfferErrorTranslationKey } from '../../types';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import styles from './OfferLoadingOrError.module.css';

const OfferLoadingOrError = () => {
  const { t } = useTranslation();
  const mobile = useMobile();
  const { offerError, offerLoading } = useOfferContext();

  if (!offerLoading && !offerError) return null;

  const errorKey = offerError ?? OfferErrorTranslationKey.SERVER;
  const showButton =
    errorKey !== OfferErrorTranslationKey.POSTCODE_REQUIRES_ADDRESS &&
    errorKey !== OfferErrorTranslationKey.INVALID_CUSTOMER_ADDRESS;

  const refreshOffer = () => window.dispatchEvent(new CustomEvent(REFRESH_OFFER_EVENT));

  return (
    <div
      data-testid="offer-loading-or-error"
      className={clsx(styles.content, {
        [styles.error]: offerError,
      })}
    >
      {offerLoading ? (
        <LoadingSpinner text={t('offer.loading')} />
      ) : (
        <>
          <Typography.Body1>{t(`offer.${errorKey}`)}</Typography.Body1>

          {showButton && (
            <Button
              variant="secondary"
              label={t('offer.reload')}
              onClick={refreshOffer}
              dataTestId="reload-offer-btn"
              size={mobile ? 'medium' : 'large'}
              loading={offerLoading}
              expanded
            />
          )}
        </>
      )}
    </div>
  );
};

export default OfferLoadingOrError;
